// extracted by mini-css-extract-plugin
export default {"player_container":"VideoCard_player_container__DZvBe","play_btn":"VideoCard_play_btn__5oYZg","play_btn_icon":"VideoCard_play_btn_icon__mgXyM"};